import { formatCurrencyNatural } from '@frontend/duck-tape';
import { usePaywallContext } from '@frontend/react-domain';
import { Icon, Text, XStack, YStack, useIsOnMobile } from '@frontend/web-react';
import { PaywallNextButton } from './PaywallNextButton';
import { usePaywallPricingContext } from './PaywallPricingContext';

export const PaywallFooter = () => {
  const { paywallState } = usePaywallContext();
  const { pricingState, selectedPlanPricing } = usePaywallPricingContext();
  const {
    navigation: { currentStep },
    promotionTranslation: { promotionDescription },
    purchase: { selectedPurchaseType },
  } = paywallState;
  const isMobile = useIsOnMobile();

  const showYouPayTodayOnPlanSelection =
    (currentStep === 'checkout' || currentStep === 'selectSubscriptionPlan') &&
    selectedPurchaseType === 'Subscription' &&
    promotionDescription;

  const displayAmount = pricingState === 'transitioning' ? undefined : selectedPlanPricing?.primaryPrice;

  return (
    <YStack className="border-t border-borderPrimary bg-trueWhite" flex={1} p={isMobile ? 'md' : 'lg'}>
      <YStack gapY="md">
        {showYouPayTodayOnPlanSelection && displayAmount !== undefined ? (
          isMobile ? (
            // Mobile: Stack vertically
            <YStack gapY="md">
              <XStack alignItems="center" gapX="sm" justifyContent="center">
                <Icon name="IconCoin" size={20} />
                <Text type="h6">What {"you'll"} pay today</Text>
                <Text className="italic font-serif" type="h4">
                  {formatCurrencyNatural(displayAmount)}
                </Text>
              </XStack>
              <PaywallNextButton />
            </YStack>
          ) : (
            // Desktop: Horizontal layout
            <XStack alignItems="center" gapX="md" justifyContent="between">
              <XStack alignItems="center" gapX="sm">
                <Icon name="IconCoin" size={24} />
                <XStack alignItems="center" gap="md">
                  <Text type="h5">What {"you'll"} pay today</Text>
                  <Text className="italic font-serif" type="h3">
                    {formatCurrencyNatural(displayAmount)}
                  </Text>
                </XStack>
              </XStack>
              {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
              <YStack className="w-[210px]">
                <PaywallNextButton />
              </YStack>
            </XStack>
          )
        ) : pricingState === 'transitioning' && showYouPayTodayOnPlanSelection ? (
          isMobile ? (
            <YStack gapY="md">
              <XStack alignItems="center" gapX="sm" justifyContent="center">
                <Icon name="IconCoin" size={20} />
                <YStack gapY="xs">
                  <YStack bg="lineGray" height={18} radius="md" width={132} />
                  <YStack bg="lineGray" height={24} radius="md" width={80} />
                </YStack>
              </XStack>
              <PaywallNextButton />
            </YStack>
          ) : (
            <XStack alignItems="center" gapX="md" justifyContent="between">
              <XStack alignItems="center" gapX="sm">
                <Icon name="IconCoin" size={24} />
                <YStack gapY="xs">
                  <YStack bg="lineGray" height={18} radius="md" width={144} />
                  <YStack bg="lineGray" height={24} radius="md" width={96} />
                </YStack>
              </XStack>
              {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
              <YStack className="w-[210px]">
                <PaywallNextButton />
              </YStack>
            </XStack>
          )
        ) : (
          <PaywallNextButton />
        )}
      </YStack>
    </YStack>
  );
};
